<template>
  <div class="detail-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>工单详情</span>
        <el-button style="float: right;" type="text" @click="goBack">返回</el-button>
        <el-button style="float: right; margin-right: 20px;" type="primary" size="small" @click="handleEdit">编辑</el-button>
      </div>
      
      <el-descriptions title="工单基本信息" :column="2" border>
        <el-descriptions-item label="工单编号">{{ billData.installBillNo }}</el-descriptions-item>
        <el-descriptions-item label="批次号">{{ billData.batchCode }}</el-descriptions-item>
        <el-descriptions-item label="推荐人姓名">{{ billData.referName }}</el-descriptions-item>
        <el-descriptions-item label="推荐人类型">{{ billData.referType }}</el-descriptions-item>
        <el-descriptions-item label="工程师姓名">{{ billData.engineerName }}</el-descriptions-item>
        <el-descriptions-item label="工程师电话">{{ billData.engineerPhone }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ billData.contactPhone }}</el-descriptions-item>
        <el-descriptions-item label="工单状态">
          <el-tag :type="getStatusType(billData.status)">{{ getStatusText(billData.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="计划数量">{{ billData.planCount }}</el-descriptions-item>
        <el-descriptions-item label="实际数量">{{ billData.realCount }}</el-descriptions-item>
        <el-descriptions-item label="区域">{{ billData.area }}</el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ billData.address }}</el-descriptions-item>
        <el-descriptions-item label="计划时间">{{ billData.planTime }}</el-descriptions-item>
        <el-descriptions-item label="实际完成时间">{{ billData.realTime }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ billData.createTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ billData.updateTime }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ billData.remark }}</el-descriptions-item>
      </el-descriptions>

      <el-divider></el-divider>

      <div style="margin-bottom: 15px; font-weight: bold; font-size: 16px;">工单日志信息</div>
      
      <el-table :data="logList" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="devId" label="设备编号" width="120"></el-table-column>
        <el-table-column prop="carNo" label="车牌号" width="140"></el-table-column>
        <el-table-column prop="devicePic" label="设备图片" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.devicePic"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.devicePic" 
              :preview-src-list="[scope.row.devicePic]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="carPic" label="车牌图片" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.carPic"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.carPic" 
              :preview-src-list="[scope.row.carPic]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="position1" label="安装位置1" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.position1"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.position1" 
              :preview-src-list="[scope.row.position1]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="position2" label="安装位置2" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.position2"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.position2" 
              :preview-src-list="[scope.row.position2]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="position3" label="安装位置3" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.position3"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.position3" 
              :preview-src-list="[scope.row.position3]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="position4" label="安装位置4" width="150">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.position4"
              style="width: 60px; height: 60px; cursor: pointer;" 
              :src="scope.row.position4" 
              :preview-src-list="[scope.row.position4]"
              fit="contain">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常' : '异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'InstallBillDetail',
  data() {
    return {
      billData: {},
      logList: []
    };
  },
  mounted() {
    const installBillNo = this.$route.query.installBillNo;
    if (installBillNo) {
      this.getDetail(installBillNo);
    } else {
      this.$message.error('工单编号不能为空');
      this.goBack();
    }
  },
  methods: {
    // 获取工单详情
    getDetail(installBillNo) {
      this.$http.post('/manage/installBill/detail', { installBillNo })
        .then(res => {
          if (res.data.code === 0) {
            this.billData = res.data.data.bill || {};
            this.logList = res.data.data.logList || [];
          } else {
            this.$message.error(res.data.message || '获取详情失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },
    
    // 编辑
    handleEdit() {
      this.$router.push({
        path: '/install/bill/edit',
        query: { installBillNo: this.billData.installBillNo }
      });
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待分配',
        1: '已分配',
        2: '进行中',
        3: '已完成',
        4: '已取消'
      };
      return statusMap[status] || '未知';
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'info',
        1: '',
        2: 'warning',
        3: 'success',
        4: 'danger'
      };
      return typeMap[status] || 'info';
    },
    
    // 返回
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
}
.box-card {
  max-width: 1200px;
  margin: 0 auto;
}
</style>

